import {
  MEDIA_ATTACHMENT_FIELD_DEFAULT_PROPS,
  MediaAttachmentFieldProps,
  FileSetValue,
} from '../core-field/media-attachment-field-props'

export type { FileSetValue }

/**
 * Named file-type constants accepted by the `accept` prop. These are the same
 * keys used by react-native-document-picker on NM; on DW they map to MIME types
 * via FILE_TYPE_MIME_MAP.
 */
export type FileTypeConstant =
  | 'allFiles'
  | 'audio'
  | 'csv'
  | 'doc'
  | 'docx'
  | 'images'
  | 'json'
  | 'pdf'
  | 'plainText'
  | 'ppt'
  | 'pptx'
  | 'video'
  | 'xls'
  | 'xlsx'
  | 'zip'

/** MIME types for each FileTypeConstant — used by DW to build the <input accept> attribute. */
export const FILE_TYPE_MIME_MAP: Record<FileTypeConstant, string> = {
  allFiles: '*/*',
  audio: 'audio/*',
  csv: 'text/csv',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  images: 'image/*',
  json: 'application/json',
  pdf: 'application/pdf',
  plainText: 'text/plain',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  video: 'video/*',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  zip: 'application/zip',
}

export const UI2_FILE_UPLOAD_FIELD_DEFAULT_PROPS: Partial<UI2FileUploadFieldProps> = {
  ...MEDIA_ATTACHMENT_FIELD_DEFAULT_PROPS,
  accept: ['images', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'plainText'],
}

export interface UI2FileUploadFieldProps extends MediaAttachmentFieldProps {
  /**
   * File types the picker will accept. Uses named constants shared across platforms;
   * each platform maps them to its own format internally. Defaults to images, PDFs,
   * and common document types.
   * @example ['images', 'pdf']
   * @example ['allFiles']
   */
  accept?: FileTypeConstant[]
}
